import cx from 'classnames'
import { ReactNode } from 'react'

interface LabelProps {
  primary?: boolean
  secondary?: boolean
  isBadge?: boolean
  hasDot?: boolean
  pulsingDot?: boolean
  className?: string
  children: ReactNode
}

const Label = ({
  primary = false,
  secondary = false,
  isBadge = false,
  hasDot = false,
  pulsingDot = false,
  className,
  children,
}: LabelProps) => (
  <span
    className={cx(
      'inline-flex items-center p-2 whitespace-nowrap',
      {
        'rounded-full border text-xs leading-none tracking-normal normal-case -my-1 transform scale-90':
          isBadge,
        'bg-pageText border-transparent text-pageBG': primary,
        'bg-transparent border-pageText text-pageText': secondary,
        'px-3': !hasDot,
        'pr-3': hasDot,
      },
      className,
    )}
  >
    {hasDot && (
      <div
        className={cx('inline-block mr-2 rounded-full w-[10px] h-[10px]', {
          'bg-pageBG': primary,
          'bg-pageText': secondary,
          'animate-shadow-pulse': pulsingDot,
        })}
      />
    )}
    {children}
  </span>
)

export default Label
